import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import { TextButton } from "../buttons/CommonButton";

const SnackbarContainer = styled.div`
	position: fixed;
	top: calc(100vh - var(--snackbar-height) - 24px);
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	-webkit-user-select: none;
	user-select: none;

	@media (max-width: 400px) {
		top: calc(100vh - var(--snackbar-height) - 80px - 24px);
	}
`;

const SnackbarContent = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 16px;
	max-width: 300px;
	height: 48px;
	padding: 0 16px;
	border-radius: 4px;
	color: var(--color-inverse-on-surface);
	background-color: var(--color-inverse-surface);
	opacity: ${(props) => (props.isOpen ? "1" : "0")};
	transform: translateY(${(props) => (props.isOpen ? "0" : "48")}px);
	transition: 0.3s;
	z-index: 3;
`;

const Label = styled.label`
	color: var(--color-inverse-on-surface);
`;

const Icon = styled.span`
	width: 24px;
	height: 24px;
	font-size: 24px;
	line-height: 24px;
	margin: 0 16px;
`;

class SnackbarComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			duration: this.props.duration,
			isOpen: false,
			isSnackbarOpen: false,
			text: this.props.text,
			icon: this.props.icon,
			actionButton: this.props.actionButton,
			autoHide: this.props.autoHide,
		};

		this.show = this.show.bind(this);
		this.hide = this.hide.bind(this);

		this.snackbarRef = React.createRef();
	}

	show(customProps) {
		this.setState({ isOpen: true, ...customProps }, () => {
			const snackbarHeight = this.snackbarRef.current.offsetHeight;
			this.snackbarRef.current.style.setProperty(
				"--snackbar-height",
				`${snackbarHeight}px`
			);

			setTimeout(() => {
				this.setState({ isSnackbarOpen: true });
			}, 10);

			if (this.state.autoHide) {
				setTimeout(() => {
					this.hide();
				}, this.state.duration);
			}
		});
	}

	hide() {
		this.setState({ isSnackbarOpen: false });
		setTimeout(() => {
			this.setState({ isOpen: false });
		}, 300);
	}

	render() {
		return this.state.isOpen
			? createPortal(
					<SnackbarContainer ref={this.snackbarRef}>
						<SnackbarContent isOpen={this.state.isSnackbarOpen}>
							<Label className="label-large">
								{this.state.text}
							</Label>
							{this.state.actionButton && (
								<TextButton
									theme="custom"
									color="var(--color-inverse-primary)"
									text={this.state.actionButton.text}
									onClick={this.state.actionButton.onClick}
								/>
							)}
							{this.state.icon && (
								<Icon
									className="material-symbol fill"
									onClick={() => {
										this.hide();
									}}
								>
									close
								</Icon>
							)}
						</SnackbarContent>
					</SnackbarContainer>,
					document.getElementsByTagName("main")[0]
			  )
			: null;
	}
}

SnackbarComponent.propTypes = {
	autoHide: PropTypes.bool,
	text: PropTypes.string.isRequired,
	icon: PropTypes.bool,
	duration: PropTypes.number,
	actionButton: PropTypes.shape({
		text: PropTypes.string.isRequired,
		onClick: PropTypes.func.isRequired,
	}),
};

SnackbarComponent.defaultProps = {
	autoHide: true,
	icon: false,
	duration: localStorage.getItem("pref-int-not-time") || 5000,
	actionButton: null,
};

export default SnackbarComponent;
